const layers = [
  {
    "type": "overlayers",
    "name": "Sobreposições",
    "visible": true,
    "layers": [
      {
        "id": 733,
        "name": "Ponto de captação e bacia de manancial",
        "url": "https://produtos.simepar.br/geobarragem/bd/wms?",
        "url_params": {
          "LAYERS": "bd:group_sia",
          "STYLES": "pgw-group_sia",
          "SRS": "EPSG:4326",
          "VIEWPARAMS": "locationid:1162",
          "ENV": "circle_fill_color:3eca8f;polygon_fill_color:b1ebce;polygon_fill_opacity:0.8;polygon_stroke_color:58d09a"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "property_params": {
          "opacity": 0.9,
          "visible": true,
          "zindex": 0
        },
        "hide_on_menu": true,
      },
      {
        "id": 739,
        "name": "Pontos de captação",
        "url": "https://produtos.simepar.br/geosimepar/forecastdev/wms?",
        "url_params": {
          "LAYERS": "forecastdev:pontocaptacao",
          "STYLES": "pgw-sia-catchment_point",
          "ENV": "circle_fill_color:7AC1FF"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "cptsia,citname,sistema,cptnome", "label_title": "SIA"}',
          ],
          "FORMAT": "SIA {0} - {1} - {2} - {3}"
        },
        "event_params": {
          "type": "click",
        },
        "property_params": {
          "opacity": 0.9,
          "visible": false,
          "zindex": 2
        },
        "icon_params":{
          "class": "icon-infohidro-pontos-captacao",
          "background_color": "#7AC1FF"
        },
      },
      {
        "id": 622,
        "name": "Bacias de mananciais",
        "url": "https://produtos.simepar.br/geosimepar/forecastdev/wms?",
        "url_params": {
          "LAYERS": "forecastdev:mananciais_sanepar",
          "STYLES": "pgw_polygon_env",
          "ENV": "stroke_color:0583F2;fill_color:FFF;stroke_width:1;fill_opacity:0.15"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "sbsname", "label_title": ""}',
            '{"key": "sbsobs", "property_child": "Q95", "label": "Q95", "suffix": ""}',
            '{"key": "sbsobs", "property_child": "area", "label": "Área", "suffix": "", "decimal_number": 1}',
          ],
          "FORMAT": "{0}<br>{1}<br>{2}",
          "icon_params":{
            "class": "icon-infohidro-bacia",
            "background_color": "#0071B0"
          },
        },
        "event_params": {
          "type": "click",
        },
        "property_params": {
          "opacity": 1,
          "visible": false,
          "zindex": 1,
          "highlightOnHoverFeature": {
            "fillColor": 'rgba(101, 156, 213, 0.5)',
            "strokeColor": '#659CD5'
          },
        }
      },
      {
        "id": 1999,
        "name": "Disponibilidade hídrica",
        "url": "https://produtos.simepar.br/geosimepar/sanepar/wms?",
        "url_params": {
          "LAYERS": "sanepar:riocaptacaoq30",
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "NAME", "label_title": ""}',
            '{"key": "DATE", "label_subtitle": "", "dateFormat": "DD/MM/YYYY"}',
            '{"key": "CLASS", "label": "Disponibilidade hídrica", "icon_label": "fiber_manual_record", "value_function": "getNameAndColorWaterAvailability"}',
            '{"key": "RIO", "label": "Rio"}',
          ],
          "FORMAT": "{0}" // custom
        },
        "icon_params":{
          "class": "mdi-chart-bubble",
          "background_color": "#0071B0"
        },
        "disabled": false,
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 1
        },
        "caption_html": {
          alwaysVisible: true,
          items:[
              { text:'Estiagem' ,color:'#FC424A' },
              { text:'Rio baixo' ,color:'#FFAB00' },
              { text:'Normal' ,color:'#0090E7' },
              { text:'Rio alto' ,color:'#00D25B' },
              { text:'Cheia' ,color:'#8F5FE8' },
          ]
        },
      },
      {
        "id": 2000,
        "name": "Estágio de Seca",
        "url": "https://produtos.simepar.br/geosimepar/forecastdev/wms?",
        "url_params": {
          "LAYERS": "forecastdev:escassez sanepar",
          "STYLES": "escassez_hidrica_style",
          "CQL_FILTER": "ehdref='SIA'"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 1
        },
        "caption_html": {
          "alwaysVisible": true,
          vertical: true,
          groupItems: [{
            items:[
                { "text":'Emergência' ,"color": "#9B44B1" },
                { "text":"Crítica" ,"color":"#FF0000" },
                { "text":"Alerta" ,"color":"#FFA500" },
                { "text":"Atenção" ,"color":"#FFFF00" },
                { "text":"Normal" ,"color":"#008000" }
            ],
          }]
        }
      },
  //     {
  //       "id": 9999,
  //       "name": "Qualidade da água",
  //       "url": "https://produtos.simepar.br/geosimepar/forecastdev/wms?sortby=sbsarea+d",
  //       "url_params": {
  //         "LAYERS": "forecastdev:customer_subbasin",
  //         "STYLES": "pgw_polygon_env",
  //         "ENV": "stroke_color:66B2FF;fill_color:CCE5FF;stroke_width:1.5",
  //         "VIEWPARAMS": "customer_id:7",
  //         "CQL_FILTER": "bacid=16"
  //       },
  //       "layer_class": "ol.layer.Tile",
  //       "layer_type": "ol.source.TileWMS",
  //       "tooltip_params": {
  //         "KEYS": [
  //           "sbsacronym",
  //           "sbsname"
  //         ],
  //         "FORMAT": "{0}<br>{1}"
  //       },
  //       "disabled": true,
  //       "property_params": {
  //         "opacity": 0.8,
  //         "visible": false,
  //         "zindex": 1
  //       },
  //       "caption_html": {
  //             alwaysVisible: true,
  //             items:[
  //                 { text:'Ruim' ,color:'#3BD79A' },
  //                 { text:'Regular' ,color:'#F39946' },
  //                 { text:'Boa' ,color:'#659CD5' },
  //             ]
  //       },
  //     },
    ]
  },
  {
    "type": "grouping",
    "name": "Hidrografia",
    "visible": true,
    "layers": [
      {
        "id": 695,
        "name": "Rios de captação",
        "url": "https://produtos.simepar.br/geosimepar/forecastdev/wms?",
        "url_params": {
          "LAYERS": "forecastdev:rioprincipalcaptacao",
          "STYLES": "pgw-linestring_env",
          "env": "stroke:0583F2"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "rpcname", "label_title": ""}',
          ],
          "FORMAT": "{0}"
        },
        "property_params": {
          "opacity": 1,
          "visible": false,
          "zindex": 3
        }
      },
      {
        "id": 696,
        "name": "Rios de lançamentos de efluentes",
        "url": "https://produtos.simepar.br/geosimepar/forecastdev/wms?",
        "url_params": {
          "LAYERS": "forecastdev:rioprincipallancamento",
          "STYLES": "pgw-linestring_env",
          "env": "stroke:E17536"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "rplname", "label_title": ""}',
          ],
          "FORMAT": "{0}"
        },
        "property_params": {
          "opacity": 1,
          "visible": false,
          "zindex": 3
        }
      },
      {
        "id": 683,
        "name": "Hidrografia do Paraná",
        "url": "https://produtos.simepar.br/geosimepar/shape/wms?",
        "url_params": {
          "LAYERS": "shape:hidrografia_iat"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "nooriginal", "label_title": ""}',
          ],
          "FORMAT": "{0}"
        },
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 3
        }
      },
      {
        "id": 748,
        "name": "Grandes bacias do Paraná",
        "url": "https://produtos.simepar.br/geobarragem/shape/wms?",
        "url_params": {
          "LAYERS": "shape:bacias_hidrograficas_parana",
          "STYLES": "pgw-polygon_env",
          "ENV": "fill_color:023373;stroke_color:023373;fill_opacity:0.8;fill_color:FFF;fill_opacity:0.05"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "nome_bh", "label_title": ""}',
          ],
          "FORMAT": "{0}"
        },
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 2,
          "highlightOnHoverFeature": {
            "fillColor": 'rgba(2, 51, 115, 0.6)',
            "strokeColor": '#023373',
          },
        }
      },
      {
        "id": 747,
        "name": "Unidades hidrográficas oficiais",
        "url": "https://produtos.simepar.br/geobarragem/shape/wms?",
        "url_params": {
          "LAYERS": "shape:unidades_hidrograficas_parana",
          "STYLES": "pgw-polygon_env",
          "ENV": "fill_color:0583F2;stroke_color:0583F2;fill_opacity:0.8;fill_color:FFF;fill_opacity:0.05"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "nome_uh", "label_title": ""}',
          ],
          "FORMAT": "{0}"
        },
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 2,
          "highlightOnHoverFeature": {
            "fillColor": 'rgba(5, 131, 242, 0.6)',
            "strokeColor": '#0583F2',
          },
        }
      },
      {
        "id": 767,
        "name": "Aquíferos",
        "url": "https://produtos.simepar.br/geosimepar/forecastdev/wms?",
        "url_params": {
          "LAYERS": "forecastdev:aquiferoaflorante"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "saanome", "label_title": ""}',
            '{"key": "saatipo", "label": "Tipo", "icon_label":"mdi-texture-box"}',
          ],
          "FORMAT": "{0} ({1})"
        },
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 1
        },
        "caption_html": {
          alwaysVisible: false,
          vertical: true,
          groupItems:[
              {
                  text: "Cárstico",
                  items:[
                      { text:'Carste da Bacia do Paraná' ,color:'#F2AB43', style: 'square'},
                  ]
              },
              {
                  text: "Fraturado",
                  items:[
                      { text:'Fraturado Centro-Sul' ,color:'#C0FF43', style: 'square' },
                      { text:'Serra Geral' ,color:'#79BA43', style: 'square' },
                  ]
              },
              {
                text: "Poroso",
                items:[
                    { text:'Alexandra - Guaraqueçaba' ,color:'#96E6FE', style: 'square' },
                    { text:'Bateias - Campo Alegre' ,color:'#8EDEF8', style: 'square' },
                    { text:'Bauru-Caiuá' ,color:'#8CDAF6', style: 'square' },
                    { text:'Cananéia' ,color:'#82CFF0', style: 'square' },
                    { text:'Castro' ,color:'#80CDEE', style: 'square' },
                    { text:'Ervalzinho' ,color:'#77C1E7', style: 'square' },
                    { text:'Furnas' ,color:'#76BCE3', style: 'square' },
                    { text:'Guabirotuba' ,color:'#72B8E1', style: 'square' },
                    { text:'Guarani' ,color:'#74BBE3', style: 'square' },
                    { text:'Itararé' ,color:'#6CB2DD', style: 'square' },
                    { text:'Palermo' ,color:'#5EA1D2', style: 'square' },
                    { text:'Passa Dois' ,color:'#5A9BCE', style: 'square' },
                    { text:'Ponta Grossa' ,color:'#5592CB', style: 'square' },
                    { text:'Rio Bonito' ,color:'#508FC8', style: 'square' },
                    { text:'Litorâneo Nordeste - Sudeste' ,color:'#436EB0', style: 'square' },
                ]
              },
          ]
        },
      }
    ]
  },
  {
    "type": "grouping",
    "name": "Outorgas da Sanepar",
    "visible": true,
    "layers": [
      {
        "id": 719,
        "name": "Poços",
        "url": "https://produtos.simepar.br/geobarragem/bd/wms?",
        "url_params": {
          "LAYERS": "bd:outorga",
          "STYLES": "pgw-grant_wells",
          "cql_filter": "tipomanancial='POÇO' and razaosocial='SANEPAR- COMPANHIA DE SANEAMENTO DO PARANÁ' and condicao='VIGENTE'"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "razaosocial", "label_subtitle": "Razão social"}',
            '{"key": "poco", "property_child": "vazao_outo", "label": "Vazão outorgada", "suffix": "m³/h"}'
          ],
          "FORMAT": "Local: {0} ({1})"
        },
        "icon_params":{
          "class": "icon-infohidro-poco",
          "background_color": "#023373"
        },
        "property_params": {
          "opacity": 1,
          "visible": false,
          "zindex": 2
        }
      },
      {
        "id": 716,
        "name": "Captação",
        "url": "https://produtos.simepar.br/geobarragem/bd/wms?",
        "url_params": {
          "LAYERS": "bd:outorga",
          "STYLES": "pgw-grant_catchment",
          "cql_filter": "razaosocial='SANEPAR- COMPANHIA DE SANEAMENTO DO PARANÁ' and condicao='VIGENTE' and tipomanancial <> 'POÇO'"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "razaosocial", "label_subtitle": "Razão social"}',
            '{"key": "poco", "property_child": "vazao_outo", "label": "Vazão outorgada", "suffix": "m³/h"}',
            '{"key": "tipomanancial", "label": "Tipo", "icon_label":"mdi-view-grid-plus-outline"}'
          ],
          "FORMAT": "{0}<BR>Tipo manancial: {1}"
        },
        "icon_params":{
          "class": "icon-infohidro-captacao",
          "background_color": "#0583F2"
        },
        "property_params": {
          "opacity": 1,
          "visible": false,
          "zindex": 2
        }
      },
      {
        "id": 721,
        "name": "Dispensa",
        "url": "https://produtos.simepar.br/geobarragem/bd/wms?",
        "url_params": {
          "LAYERS": "bd:outorga_dispensa",
          "STYLES": "pgw-grant_exemption",
          "CQL_FILTER": "razaosocial='SANEPAR- COMPANHIA DE SANEAMENTO DO PARANÁ'"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "razaosocial", "label_subtitle": "Razão social"}',
            '{"key": "poco", "property_child": "vazao_outo", "label": "Vazão outorgada", "suffix": "m³/h"}'
          ],
          "FORMAT": "{0}<br>Tipo: {1}"
        },
        "icon_params":{
          "class": "icon-infohidro-dispensa",
          "background_color": "#00C4F0"
        },
        "property_params": {
          "opacity": 1,
          "visible": false,
          "zindex": 2
        }
      },
    ]
  },
  {
    "type": "grouping",
    "name": "Outorgas de terceiros",
    "visible": true,
    "layers": [
      {
        "id": 718,
        "name": "Poços",
        "url": "https://produtos.simepar.br/geobarragem/bd/wms?",
        "url_params": {
          "LAYERS": "bd:outorga",
          "STYLES": "pgw-grant_wells",
          "cql_filter": "tipomanancial='POÇO' and razaosocial<>'SANEPAR- COMPANHIA DE SANEAMENTO DO PARANÁ' and condicao='VIGENTE'"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "razaosocial", "label_subtitle": "Razão social"}',
            '{"key": "poco", "property_child": "vazao_outo", "label": "Vazão outorgada", "suffix": "m³/h"}'
          ],
          "FORMAT": "Local: {0}"
        },
        "icon_params":{
          "class": "icon-infohidro-poco",
          "background_color": "#592520"
        },
        "property_params": {
          "opacity": 1,
          "visible": false,
          "zindex": 2
        }
      },
      {
        "id": 717,
        "name": "Captação",
        "url": "https://produtos.simepar.br/geobarragem/bd/wms?",
        "url_params": {
          "LAYERS": "bd:outorga",
          "STYLES": "pgw-grant_catchment",
          "CQL_FILTER": "razaosocial<>'SANEPAR- COMPANHIA DE SANEAMENTO DO PARANÁ'  and condicao='VIGENTE' and tipomanancial <> 'POÇO' "
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "razaosocial", "label_subtitle": "Razão social"}',
            '{"key": "poco", "property_child": "vazao_outo", "label": "Vazão outorgada", "suffix": "m³/h"}',
            '{"key": "tipomanancial", "label": "Tipo", "icon_label":"mdi-view-grid-plus-outline"}'
          ],
          "FORMAT": "{0}<BR>Tipo manancial: {1}"
        },
        "icon_params":{
          "class": "icon-infohidro-captacao",
          "background_color": "#8C402E"
        },
        "property_params": {
          "opacity": 1,
          "visible": false,
          "zindex": 2
        }
      },
      {
        "id": 720,
        "name": "Dispensa",
        "url": "https://produtos.simepar.br/geobarragem/bd/wms?",
        "url_params": {
          "LAYERS": "bd:outorga_dispensa",
          "STYLES": "pgw-grant_exemption",
          "CQL_FILTER": "razaosocial<>'SANEPAR- COMPANHIA DE SANEAMENTO DO PARANÁ'"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "razaosocial", "label_subtitle": "Razão social"}',
            '{"key": "poco", "property_child": "vazao_outo", "label": "Vazão outorgada", "suffix": "m³/h"}'
          ],
          "FORMAT": "{0}<br>Tipo: {1}"
        },
        "icon_params":{
          "class": "icon-infohidro-dispensa",
          "background_color": "#E17536"
        },
        "property_params": {
          "opacity": 1,
          "visible": false,
          "zindex": 2
        }
      },
      {
        "id": 722,
        "name": "Aproveitamento Hidrelétrico",
        "url": "https://produtos.simepar.br/geobarragem/bd/wms?",
        "url_params": {
          "LAYERS": "bd:outorga_aprov_hidreletrico",
          "STYLES": "pgw-grant_hydroelectric_use"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "razaosocial", "label_subtitle": "Razão social"}',
            '{"key": "cod_otto", "label": "Código OTTO", "icon_label": "mdi-map-outline"}',
            '{"key": "potencial", "label": "Potencial", "icon_label": "mdi-flash-outline"}'
          ],
          "FORMAT": "{0} <br>Código OTTO: {1}<br>Potencial: {2}"
        },
        "icon_params":{
          "class": "icon-infohidro-aproveitamento-hidreletrico",
          "background_color": "#F2AA80"
        },
        "property_params": {
          "opacity": 1,
          "visible": false,
          "zindex": 2
        }
      }
    ]
  },
];

export default layers;
